/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import {
  BotChatContainer,
  BotChatMessage,
  BotMsgMeta,
  BotMsgOptions,
  BotMsgSection,
} from './styled';
import { Skeleton, Tooltip } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import FeedbackContainer from './FeedbackContainer';
import MetricList from './response-components/MetricCardList';
import MarkdownComponent from './response-components/Markdown';
import NextQuestion from './response-components/NextQuestion';
import { getBotAnswerText } from '../utils';
import apptracker from '@utils/sensor/apptracker';
import { PROMPT_COPY_ANSWER } from '@src/utils/sensor/track';
import copy from 'copy-to-clipboard';

const RESPONSE_COMP_MAP = {
  markdown: MarkdownComponent,
  metricChart: MetricList,
};

function MarkdownAndCharts({ botData, timestamp, allMetricsObj, allMetricMeta }) {
  return (
    <BotChatMessage>
      {botData?.length > 0 || timestamp ? (
        (botData || []).map((section, index) => {
          const CurWidget = RESPONSE_COMP_MAP[section.type];
          if (!CurWidget) {
            return null;
          }
          return (
            <CurWidget
              key={index}
              {...section}
              allMetricsObj={allMetricsObj}
              allMetricMeta={allMetricMeta}
            />
          );
        })
      ) : (
        <Skeleton active />
      )}
    </BotChatMessage>
  );
}

// This component has performance issue because of rendering Markdown component
// if we get the timestamp it means the response ends and we will not update this component
const MemoMarkDownAndCharts = React.memo(MarkdownAndCharts, (prevProps, props) => {
  return props.timestamp && prevProps.timestamp === props.timestamp;
});

function BotChat({
  userMsg,
  timestamp,
  botData,
  getStream,
  isLoading,
  allMetricsObj,
  allMetricMeta,
}) {
  const INITIAL_COPY_TEXT = 'Copy Response';
  const [copyText, setCopyText] = useState(INITIAL_COPY_TEXT);

  const text = timestamp ? userMsg + '\n' + getBotAnswerText(botData) : '';

  const copyResponseToClipboard = () => {
    apptracker(PROMPT_COPY_ANSWER, {
      copyAnswer: text,
    });
    copy(text);
    setCopyText('Copied to clipboard');
  };

  const nextQuestionPart = (botData || []).find((block) => block.type === 'nextQuestion');

  return (
    <BotChatContainer>
      <BotMsgMeta>
        <h4>PromptAI</h4>
      </BotMsgMeta>

      <BotMsgSection>
        <MemoMarkDownAndCharts
          botData={botData}
          timestamp={timestamp}
          allMetricsObj={allMetricsObj}
          allMetricMeta={allMetricMeta}
        />
        {timestamp ? (
          <BotMsgOptions>
            <Tooltip title={copyText}>
              <CopyOutlined
                onClick={copyResponseToClipboard}
                onMouseLeave={() => setCopyText(INITIAL_COPY_TEXT)}
                style={{ color: '#828282', height: '20px', marginTop: '-12px' }}
              />
            </Tooltip>
          </BotMsgOptions>
        ) : null}
      </BotMsgSection>
      {nextQuestionPart ? (
        <NextQuestion getStream={getStream} isLoading={isLoading} {...nextQuestionPart} />
      ) : null}
      <FeedbackContainer userMsg={userMsg} botMsg={text} timestamp={timestamp} />
    </BotChatContainer>
  );
}

export default BotChat;
